import React from 'react';
export function Footer() {
  return <footer className="bg-bg-secondary border-t border-cyan/10 py-10 px-6 text-center relative z-10" data-id="element-100">
      <div className="flex items-center justify-center gap-3 mb-4" data-id="element-101">
        <img src="https://cdn.magicpatterns.com/uploads/ruDyDBcXCQm2ZT5vfYephk/LOGO_PROFUMIND.png" alt="Profumind" className="w-8 h-8 rounded-full object-cover" data-id="element-102" />
        <span className="text-[14px] font-heading font-bold uppercase tracking-[0.15em] text-white-dim" data-id="element-103">
          Profumind
        </span>
      </div>
      <p className="text-[12px] text-white/25" data-id="element-104">
        © {new Date().getFullYear()} Profumind · All rights reserved.
      </p>
    </footer>;
}